import React from 'react';

import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PersonIcon from '@mui/icons-material/Person';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';

import ConnectionsCard from './ConnectionsCard';
import GlobalCard from './GlobalCard';
import RankingCard from './RankingCard';
import ScoreCard from './ScoreCard';
import SummaryCard from './SummaryCard';
import { useUserConnections } from '../hooks/useUserConnections';

type Props = {
  userId: string;
  loggedUserId: string;
  stats: any;
  loadingStats: boolean;
};

const AccordionHighlights: React.FC<Props> = ({ userId, loggedUserId, stats, loadingStats }) => {
  const muiTheme = useTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('sm'));

  const { connections, loading: loadingConnections } = useUserConnections(userId, loggedUserId);

  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
          <Typography variant="h6" fontWeight="bold">
            Highlights
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Stack
          direction={isMobile ? 'column' : 'column'}
          spacing={isMobile ? 1 : 2}
          sx={{ width: '100%' }}
        >
          <Stack
            direction={isMobile ? 'column' : 'row'}
            spacing={isMobile ? 1 : 2}
            sx={{
              flex: 1,
              width: '100%',
              height: '100%',
            }}
          >
            <Box sx={{ width: isMobile ? '100%' : '50%' }}>
              <GlobalCard icon={<PersonIcon />} title="Sobre">
                <SummaryCard userId={userId} />
              </GlobalCard>
            </Box>
            <Box sx={{ width: isMobile ? '100%' : '50%' }}>
              <GlobalCard icon={<EmojiEventsIcon />} title="Conquistas">
                <Stack
                  direction={isMobile ? 'row' : 'row'}
                  spacing={0.5}
                  sx={{
                    width: '100%',
                    height: '100%',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <RankingCard
                    ranking={stats?.ranking ?? null}
                    loading={loadingStats}
                    progress={stats?.progress ?? 0}
                  />
                  <ScoreCard
                    score={stats?.total_points ?? null}
                    loading={loadingStats}
                    progress={stats?.progress ?? 0}
                  />
                </Stack>
              </GlobalCard>
            </Box>
          </Stack>

          <Stack
            direction="column"
            spacing={isMobile ? 1 : 2}
            sx={{
              flex: 1,
              width: isMobile ? '100%' : '50%',
              height: '100%',
              paddingRight: isMobile ? 0 : 1,
            }}
          >
            <ConnectionsCard
              connections={connections?.common_nodes ?? []}
              loading={loadingConnections}
            />
          </Stack>
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
};

export default AccordionHighlights;
